{{ timeRemaining$ | async | date:'mm:ss' }}